














































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import GJgrowEventCreateFormFormat from '../GJgrowEventCreateFormFormat.vue';
import { required } from 'vuelidate/lib/validators';
import { jgrowEventCreateModule } from '@/store/modules/frames/jgrow-event-create.module';
import { EventParam } from '@/models/jgrow/event-param';
import GVTag from '@/components/GVTag.vue';
import moment from 'moment';
import { globalModule } from '@/store/modules/global.module';

@Component({
  name: 'GJgrowEventCreateTermExamAtAfter',
  components: { GVTag, GJgrowEventCreateFormFormat },
  computed: {},
  methods: {},
  validations: {
    afterExamStartDate: { required },
    afterExamEndDate: { required },
  },
})
export default class GJgrowEventCreateTermExamAtAfter extends mixins(GPageBase) {
  isStartDateChange: boolean = false;
  mounted() {}

  get isChecked(): boolean {
    return this.eventParam.afterExam;
  }

  get afterExamStartDate(): Date {
    return this.eventParam.afterExamStartDate;
  }

  get afterExamEndDate(): Date {
    return this.eventParam.afterExamEndDate;
  }

  get eventParam(): EventParam {
    return jgrowEventCreateModule.params;
  }

  get isStartDateInvalid(): boolean {
    return this.$v.afterExamStartDate.$dirty && this.$v.afterExamStartDate.$invalid;
  }
  get isStartDateBeforeCurrentTime(): boolean {
    return moment(this.eventParam.afterExamStartDate) <= moment(new Date()).add(-5, 'm');
  }

  get isEndDateInvalid(): boolean {
    return this.$v.afterExamEndDate.$dirty && this.$v.afterExamEndDate.$invalid;
  }

  get isEndDateBeforeStartTime(): boolean {
    return !this.$v.afterExamStartDate.$invalid && !this.$v.afterExamEndDate.$invalid && moment(this.eventParam.afterExamEndDate) <= moment(this.eventParam.afterExamStartDate);
  }

  touchDeadline(): void {
    this.$v.afterExamEndDate.$touch();
  }

  // iviewのDatePickerのoptionsに入れるオブジェクト
  get dateOption() {
    const startDate: Date = globalModule.isNewSchoolYear ? new Date(globalModule.selectedSchoolYear, 3, 1) : new Date();
    return {
      disabledDate(date: Date) {
        //終了日を開始日+1より手前の日付で設定を不可能にする
        return (date && moment(date) < moment(startDate).add(-1, 'd')) || moment(new Date(globalModule.selectedSchoolYear + 1, 3, 1)) <= moment(date);
      },
    };
  }

  /**
   * チェックボックス「実施する」変化時
   * false（チェックが外れた）の時だけ、バリデーションをリセットする
   */
  changeCheckbox(data: boolean) {
    if (!data) {
      this.$v.$reset();
    }
  }

  /**
   * 開始時間変更時
   */
  handleStartDateChange(value: string) {
    this.isStartDateChange = true;
    this.eventParam.afterExamStartDate = value === '' ? null : moment(value).toDate();
    this.$v.afterExamStartDate.$touch();
  }

  /**
   * 終了時間変更時
   */
  handleEndDateChange(value: string) {
    this.eventParam.afterExamEndDate = value === '' ? null : moment(value).toDate();
    this.touchDeadline();
  }

  touch() {
    if (this.isChecked) {
      this.$v.$touch();
    }
  }

  // 実施する（チェックボックス）がチェックされている場合のみ判定する
  isValid(): boolean {
    if (this.isChecked) {
      return !this.isStartDateInvalid && !this.isEndDateInvalid && !this.isEndDateBeforeStartTime;
    } else {
      return true;
    }
  }
}
